module.exports = __webpack_public_path__ + "img/reset.4e81174f.jpg";